/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { Injectable } from '@angular/core';

@Injectable()
export class ConfigService {

  private static apiHost: string;
  private static debug: boolean = true;
  private static secure: boolean = false;
  private static withCredentials: boolean = false;

  public app: any;
  public appLayout: any;
  public breakpoint: any;

  public static setApiHost(host: string): void {
    this.apiHost = host;
  }

  public static getApiHost(): string {
    if (!this.apiHost)
    {
      console.log('No API Host defined in environment.json configuration file');
    }
    return this.apiHost;
  }

  public static setDebugMode(isEnabled: boolean): void {
    this.debug = isEnabled;
  }

  public static debuggable(): boolean {
    return this.debug;
  }

  public static setSecureWebSockets(): void {
    this.secure = true;
  }

  public static unsetSecureWebSockets(): void {
    this.secure = false;
  }

  public static isSecureWebSocketsSet(): boolean {
    return this.secure;
  }

  public static setRequestOptionsCredentials(withCredentials: boolean = false): void {
    this.withCredentials = withCredentials;
  }

  public static getRequestOptionsCredentials(): boolean {
    return this.withCredentials;
  }

  constructor() {
    this.app = {
      name: 'MaterialLab'
    };
    this.appLayout = {
      isApp_Boxed: false,
      isApp_SidebarLeftCollapsed: false,
      isApp_MobileSidebarLeftOpen: false,
      isApp_SidebarRightOpen: false,
      isApp_BackdropVisible: false
    };
    this.breakpoint = {
      'desktopLG': 1280,
      'desktop': 992,
      'tablet': 768,
      'mobile': 480
    };
  }

}
